<template>
  <a href="https://www.patreon.com/gardamuse" :style="cssVars" class="patreon-button" />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    label: String
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/patreon-banner.webp') + ')'
      }
    }
  }
})
export default class PatreonButton extends Vue {
  label!: string
}
</script>

<style scoped lang="scss">
.patreon-button {
  background: var(--background-image);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  width: 1fr;
  //max-width: 300px;
  height: 200px;
  //margin: 10px auto;
  border: $component-border-style;
  backface-visibility: hidden;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.024) translateY(0px) translateX(0px);
  }
}
</style>
